import React from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EngineeringIcon from '@mui/icons-material/Engineering';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import DevicesIcon from '@mui/icons-material/Devices';

export const swimlaneData = [
  {
    title: 'Product Management',
    icon: <AccountCircleIcon sx={{ color: '#1976d2', fontSize: '1.5rem' }} />,
    backgroundColor: 'rgba(25, 118, 210, 0.05)',
    cards: [
      {
        id: 'project-charter',
        title: 'Project Charter',
        owner: 'Sarah Chen',
        dueDate: '2/28/2025 - 3/14/2025',
        progress: 100,
        dependencies: [],
        outputs: ["DDP"],
        completionCriteria: '3 Documents, 1 Reviews',
        borderColor: '#1976d2',
        variant: 'Completed',
        gridColumn: 1, // Position in the 1st column of the grid
        gridRow: 1     // Position in the 1st row of the grid
      },
      {
        id: 'prd',
        title: 'DDP',
        owner: 'Sarah Chen',
        dueDate: '3/14/2025 - 3/29/2025',
        progress: 50,
        dependencies: ["Project Charter"],
        outputs: ['CIR', 'DIR'],
        completionCriteria: '2 Documents, 1 Reviews',
        borderColor: '#1976d2',
        variant: 'Default',
        gridColumn: 2, // Position in the 2nd column of the grid
        gridRow: 1     // Position in the 1st row of the grid
      },
    ],
  },
  {
    title: 'Clinical Engineering',
    icon: <LocalHospitalIcon sx={{ color: 'red', fontSize: '1.5rem' }} />,
    backgroundColor: 'rgba(211, 47, 47, 0.05)',
    cards: [
      {
        id: 'csr',
        title: 'CIR',
        owner: 'Dr. Emily Wong',
        dueDate: '3/29/2025 - 4/14/2025',
        progress: 0,
        dependencies: ["DDP"],
        outputs: ["CHA"],
        completionCriteria: '2 Documents, 1 Reviews',
        borderColor: 'red',
        variant: 'Default',
        gridColumn: 3, // Position in the 3rd column of the grid
        gridRow: 1     // Position in the 1st row of the grid
      },
    ],
  },
  {
    title: 'Systems Engineering',
    icon: <EngineeringIcon sx={{ color: 'text.secondary', fontSize: '1.5rem' }} />,
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    cards: [
      {
        id: 'dir',
        title: 'DIR',
        owner: 'Michael Zhang',
        dueDate: '3/29/2025 - 4/14/2025',
        progress: 0,
        dependencies: ["DDP"],
        outputs: ["SAD"],
        completionCriteria: '2 Documents, 2 Reviews',
        borderColor: 'grey',
        variant: 'Default',
        gridColumn: 3, // Position in the 3rd column of the grid
        gridRow: 2     // Position in the 2nd row of the grid
      },
    ],
  },
  {
    title: 'Hardware Engineering',
    icon: <DevicesIcon sx={{ color: 'orange', fontSize: '1.5rem' }} />,
    backgroundColor: 'rgba(251, 192, 45, 0.05)',
    cards: [],
  },
];
